import { render, staticRenderFns } from "./SpecialQuestionDetail.vue?vue&type=template&id=3127471b&scoped=true"
import script from "./SpecialQuestionDetail.vue?vue&type=script&lang=js"
export * from "./SpecialQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialQuestionDetail.vue?vue&type=style&index=0&id=3127471b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127471b",
  null
  
)

export default component.exports